import { render } from "./ArticleFormModal.vue?vue&type=template&id=f59b4bd4"
import script from "./ArticleFormModal.vue?vue&type=script&lang=js"
export * from "./ArticleFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__